import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
// import ColorType from "@/components/functionals/ColorType.vue";
import { formatMonto } from "@/utils";
export default [
  {
    prop: "Id",
    label: "NO",
    width: 70,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "ContactName",
    label: "Cliente",
    minWidth: 250
  },
  {
    prop: "Name",
    label: "Negociación",
    minWidth: 300
  },
  {
    prop: "Amount",
    label: "Monto total",
    width: 130,
    sortable: true,
    formatter: (row) => formatMonto(row.Amount)
  },
  {
    prop: "Product.Description",
    label: "Clasificacion",
    align: "center",
    width: 130,
    sortable: true
  },
  {
    prop: "Quantity",
    label: "Cantidad",
    width: 110,
    sortable: true
  },
  {
    prop: "UnitPrice",
    label: "P. Unitario",
    width: 120,
    formatter: (row) => formatMonto(row.UnitPrice)
  },
  {
    prop: "ProductName",
    label: "Producto",
    minWidth: 120
  },
  {
    label: "Contacto",
    prop: "ContactName",
    minWidth: 200
  },
  {
    prop: "Currency.Name",
    label: "Moneda",
    width: 100
  },
  {
    prop: "DaysLate",
    label: "Dias abierta",
    //formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "DayOnPhase",
    label: "Días en etapa",
    //formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "InitialDate",
    label: "Fecha de creacion",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "FinalDate",
    label: "Fecha de cierre",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "LastUpdatedAt",
    label: "Fecha de Fase",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "CreatedByUser.FullName",
    label: "Vendedor",
    formatter: ImagePerson,
    minWidth: 220,
    attrs: {
      imgKey: "UpdatedByUser.ImageUrl"
    }
  },
  {
    prop: "CreatedByUser.FullName",
    label: "Creador",
    formatter: ImagePerson,
    minWidth: 250,
    attrs: {
      imgKey: "UpdatedByUser.ImageUrl"
    }
  },
  {
    label: "Sop. Ventas",
    prop: "SupportSeller.FullName",
    minWidth: 250,
    formatter: ImagePerson,
    attrs: {
      imgKey: "SupportSeller.imageUrl"
    }
  },
  {
    label: "Razón de Perdida",
    prop: "Reason",
    minWidth: 200,
    formatter: (row) => row.Reason && row.Reason.substring(0, 50) + "..."
  }
];
